var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberHelpRectSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 1.34px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-6 {\r\n        font-size: 8.82px;\r\n        stroke: 0;\r\n        fill: #000;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MemberHelpRectSolid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberRectSolid"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.15,
    y: 46.22,
    width: 41.78,
    height: 108.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 150.92,
    y1: 46.22,
    x2: 109.15,
    y2: 46.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 109.15,
    y1: 46.22,
    x2: 109.15,
    y2: 154.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 109.15,
    y1: 154.84,
    x2: 150.92,
    y2: 154.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 150.92,
    y1: 154.84,
    x2: 150.92,
    y2: 46.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 104.97,
    y1: 30.08,
    x2: 155.1,
    y2: 30.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 150.92,
    y1: 30.08,
    x2: 148.83,
    y2: 32.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 150.92,
    y1: 30.08,
    x2: 153.01,
    y2: 27.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 150.92,
    y1: 30.08,
    x2: 150.92,
    y2: 25.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 150.92,
    y1: 30.08,
    x2: 150.92,
    y2: 42.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 109.15,
    y1: 30.08,
    x2: 107.06,
    y2: 32.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 109.15,
    y1: 30.08,
    x2: 111.24,
    y2: 27.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 109.15,
    y1: 30.08,
    x2: 109.15,
    y2: 25.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 109.15,
    y1: 30.08,
    x2: 109.15,
    y2: 42.04
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(118.62 27.38)"
  }, "Width"), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.08,
    y1: 42.04,
    x2: 91.08,
    y2: 159.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 91.08,
    y1: 154.84,
    x2: 88.99,
    y2: 152.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 91.08,
    y1: 154.84,
    x2: 93.17,
    y2: 156.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.08,
    y1: 154.84,
    x2: 86.9,
    y2: 154.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.08,
    y1: 154.84,
    x2: 104.97,
    y2: 154.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 91.08,
    y1: 46.22,
    x2: 88.99,
    y2: 44.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 91.08,
    y1: 46.22,
    x2: 93.17,
    y2: 48.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.08,
    y1: 46.22,
    x2: 86.9,
    y2: 46.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.08,
    y1: 46.22,
    x2: 104.97,
    y2: 46.22
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(88.38 112.13) rotate(-90)"
  }, "Depth"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberHelpRectSolid);
export default __webpack_public_path__ + "static/media/MemberHelpRectSolid.812ab1beea5af13c5f9e8155e57a4dd5.svg";
export { ForwardRef as ReactComponent };